var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAccess())?_c('button',{staticClass:"bulletin-button",class:{
    'primary-button': _vm.variant === 'primary',
    'secondary-button': _vm.variant === 'secondary',
    'green-button': _vm.variant === 'green',
    'tertiary-button': _vm.variant === 'tertiary',
    'sm-button': _vm.size === 'sm',
    'xsm-button': _vm.size === 'xsm',
    'xxsm-button': _vm.size === 'xxsm',
    'no-min-width': _vm.noMinWidth,
    'full-width': _vm.fullWidth,
    loading: _vm.loading,
    disabled: _vm.disabled || _vm.loading,
  },attrs:{"data-test-id":_vm.getDataTestId()},on:{"click":function($event){return _vm.handleClick($event)}}},[_c('div',{staticClass:"slot-wrapper"},[(_vm.loading)?_c('span',{staticClass:"button-loader mr-15"},[_c('loader-static',{attrs:{"dark":_vm.variant === 'secondary'}})],1):_vm._e(),_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }